export const LeadStatus = {
  IN_PROGRESS: 'progress',
  FAILED: 'failed',
  INTERRUPTED: 'interrupted',
  DUPLICATE: 'duplicate',
  SUCCESS: 'success'
}

export const LEAD_TIMEOUT = 3000
